/* tslint:disable */
/* eslint-disable */
/**
 * MedicalOperations API
 * This is an OpenAPI for the MedicalOperations Microservice
 *
 * OpenAPI spec version: 0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AddNewItemRequestInner } from '../models';
import { AddNewItemResponse } from '../models';
import { CreateNewInventoryRequest } from '../models';
import { CreateNewInventoryResponse } from '../models';
import { DeleteInventoryItemResponse } from '../models';
import { EditInventoryItemResponse } from '../models';
import { EditInventoryRequest } from '../models';
import { EditInventoryResponse } from '../models';
import { GetAllInventoriesResponse } from '../models';
import { GetCollectionItemsResponse } from '../models';
import { GetInventoryCollectionFieldsResponse } from '../models';
import { GetInventoryItemResponse } from '../models';
import { GetInventoryItemsByNameResponse } from '../models';
import { GetInventoryResponse } from '../models';
import { ToggleInventoryStatusResponse } from '../models';
/**
 * InventoryApi - axios parameter creator
 * @export
 */
export const InventoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This Api allows users to Add a new Item to a specific Collection in the inventory
         * @summary Add New Item to the Inventory Collection
         * @param {string} collectionID ID of the collection to be used
         * @param {Array<AddNewItemRequestInner>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewItem: async (collectionID: string, body?: Array<AddNewItemRequestInner>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'collectionID' is not null or undefined
            if (collectionID === null || collectionID === undefined) {
                throw new RequiredError('collectionID','Required parameter collectionID was null or undefined when calling addNewItem.');
            }
            const localVarPath = `/Inventory/Items/{collectionID}`
                .replace(`{${"collectionID"}}`, encodeURIComponent(String(collectionID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * This Api allows users to create a new Inventory
         * @summary Create new Inventory
         * @param {string} templateID ID of the template to be used
         * @param {CreateNewInventoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewInventory: async (templateID: string, body?: CreateNewInventoryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateID' is not null or undefined
            if (templateID === null || templateID === undefined) {
                throw new RequiredError('templateID','Required parameter templateID was null or undefined when calling createNewInventory.');
            }
            const localVarPath = `/Inventory/{templateID}`
                .replace(`{${"templateID"}}`, encodeURIComponent(String(templateID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * This Api allows users to Delete an Item from a specific Collection
         * @summary Delete a specific Item
         * @param {string} collectionID ID of the collection to be modified
         * @param {string} itemID ID of the item to be used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInventoryItem: async (collectionID: string, itemID: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'collectionID' is not null or undefined
            if (collectionID === null || collectionID === undefined) {
                throw new RequiredError('collectionID','Required parameter collectionID was null or undefined when calling deleteInventoryItem.');
            }
            // verify required parameter 'itemID' is not null or undefined
            if (itemID === null || itemID === undefined) {
                throw new RequiredError('itemID','Required parameter itemID was null or undefined when calling deleteInventoryItem.');
            }
            const localVarPath = `/Inventory/Items/{collectionID}/{itemID}`
                .replace(`{${"collectionID"}}`, encodeURIComponent(String(collectionID)))
                .replace(`{${"itemID"}}`, encodeURIComponent(String(itemID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * This API allows the users to edit the name of specific Inventory
         * @summary Edit Inventory Name
         * @param {string} inventoryID ID of the Inventory to be used
         * @param {EditInventoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editInventory: async (inventoryID: string, body?: EditInventoryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inventoryID' is not null or undefined
            if (inventoryID === null || inventoryID === undefined) {
                throw new RequiredError('inventoryID','Required parameter inventoryID was null or undefined when calling editInventory.');
            }
            const localVarPath = `/Inventory/{inventoryID}`
                .replace(`{${"inventoryID"}}`, encodeURIComponent(String(inventoryID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * This API allows the users to edit an item in a specific Inventory
         * @summary Edit Inventory Item
         * @param {string} itemID ID of the item to be modified
         * @param {Array<AddNewItemRequestInner>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editInventoryItem: async (itemID: string, body?: Array<AddNewItemRequestInner>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemID' is not null or undefined
            if (itemID === null || itemID === undefined) {
                throw new RequiredError('itemID','Required parameter itemID was null or undefined when calling editInventoryItem.');
            }
            const localVarPath = `/Inventory/Items/{itemID}`
                .replace(`{${"itemID"}}`, encodeURIComponent(String(itemID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers!['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * This API allows the users to get all Deactivated Inventories
         * @summary Gets all Deactivated Inventories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeactivatedInventories: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Inventory/Deactivated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * This API allows the users to get all Inventories
         * @summary Gets all Inventories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInventories: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Inventory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * This API allows the users to retrieve a specific Collection items
         * @summary Gets All Items in a specific Collection
         * @param {string} collectionID ID of the collection to be used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionItems: async (collectionID: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'collectionID' is not null or undefined
            if (collectionID === null || collectionID === undefined) {
                throw new RequiredError('collectionID','Required parameter collectionID was null or undefined when calling getCollectionItems.');
            }
            const localVarPath = `/Inventory/Items/{collectionID}`
                .replace(`{${"collectionID"}}`, encodeURIComponent(String(collectionID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * This API allows the users to retrieve a specific Inventory
         * @summary Gets Inventory by ID
         * @param {string} inventoryID ID of the Inventory to be used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventory: async (inventoryID: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inventoryID' is not null or undefined
            if (inventoryID === null || inventoryID === undefined) {
                throw new RequiredError('inventoryID','Required parameter inventoryID was null or undefined when calling getInventory.');
            }
            const localVarPath = `/Inventory/{inventoryID}`
                .replace(`{${"inventoryID"}}`, encodeURIComponent(String(inventoryID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * This API allows the users to retrieve a specific Inventory Collection Fields
         * @summary Gets All Fields in a specific Inventory Collection
         * @param {string} collectionID ID of the Collection to be used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryCollectionFields: async (collectionID: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'collectionID' is not null or undefined
            if (collectionID === null || collectionID === undefined) {
                throw new RequiredError('collectionID','Required parameter collectionID was null or undefined when calling getInventoryCollectionFields.');
            }
            const localVarPath = `/Inventory/CollectionFields/{collectionID}`
                .replace(`{${"collectionID"}}`, encodeURIComponent(String(collectionID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * This API allows the users to retrieve a specific inventory item
         * @summary Gets an inventory Item by id
         * @param {string} itemID ID of the item to be modified
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryItem: async (itemID: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemID' is not null or undefined
            if (itemID === null || itemID === undefined) {
                throw new RequiredError('itemID','Required parameter itemID was null or undefined when calling getInventoryItem.');
            }
            const localVarPath = `/Inventory/Item/{itemID}`
                .replace(`{${"itemID"}}`, encodeURIComponent(String(itemID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * This API allows the users to retrieve inventory items by Name
         * @summary Gets inventory Items by Name
         * @param {string} Name Name of the item(s)
         * @param {number} [offset] Offset number for pagination
         * @param {number} [limit] Number of items per page for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryItemsByName: async (Name: string, offset?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'Name' is not null or undefined
            if (Name === null || Name === undefined) {
                throw new RequiredError('Name','Required parameter Name was null or undefined when calling getInventoryItemsByName.');
            }
            const localVarPath = `/Inventory/Items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            if (Name !== undefined) {
                localVarQueryParameter['Name'] = Name;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * API allows the users to change the status of inventory to active/inactive
         * @summary Toggle Inventory Status
         * @param {string} inventoryID ID of the Inventory to be used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleInventoryStatus: async (inventoryID: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inventoryID' is not null or undefined
            if (inventoryID === null || inventoryID === undefined) {
                throw new RequiredError('inventoryID','Required parameter inventoryID was null or undefined when calling toggleInventoryStatus.');
            }
            const localVarPath = `/Inventory/ToggleInventoryStatus/{inventoryID}`
                .replace(`{${"inventoryID"}}`, encodeURIComponent(String(inventoryID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Access-Token")
                    : await configuration.apiKey;
                localVarHeaderParameter["Access-Token"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryApi - functional programming interface
 * @export
 */
export const InventoryApiFp = function(configuration?: Configuration) {
    return {
        /**
         * This Api allows users to Add a new Item to a specific Collection in the inventory
         * @summary Add New Item to the Inventory Collection
         * @param {string} collectionID ID of the collection to be used
         * @param {Array<AddNewItemRequestInner>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNewItem(collectionID: string, body?: Array<AddNewItemRequestInner>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<AddNewItemResponse>>> {
            const localVarAxiosArgs = await InventoryApiAxiosParamCreator(configuration).addNewItem(collectionID, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This Api allows users to create a new Inventory
         * @summary Create new Inventory
         * @param {string} templateID ID of the template to be used
         * @param {CreateNewInventoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNewInventory(templateID: string, body?: CreateNewInventoryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<CreateNewInventoryResponse>>> {
            const localVarAxiosArgs = await InventoryApiAxiosParamCreator(configuration).createNewInventory(templateID, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This Api allows users to Delete an Item from a specific Collection
         * @summary Delete a specific Item
         * @param {string} collectionID ID of the collection to be modified
         * @param {string} itemID ID of the item to be used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInventoryItem(collectionID: string, itemID: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<DeleteInventoryItemResponse>>> {
            const localVarAxiosArgs = await InventoryApiAxiosParamCreator(configuration).deleteInventoryItem(collectionID, itemID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This API allows the users to edit the name of specific Inventory
         * @summary Edit Inventory Name
         * @param {string} inventoryID ID of the Inventory to be used
         * @param {EditInventoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editInventory(inventoryID: string, body?: EditInventoryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<EditInventoryResponse>>> {
            const localVarAxiosArgs = await InventoryApiAxiosParamCreator(configuration).editInventory(inventoryID, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This API allows the users to edit an item in a specific Inventory
         * @summary Edit Inventory Item
         * @param {string} itemID ID of the item to be modified
         * @param {Array<AddNewItemRequestInner>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editInventoryItem(itemID: string, body?: Array<AddNewItemRequestInner>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<EditInventoryItemResponse>>> {
            const localVarAxiosArgs = await InventoryApiAxiosParamCreator(configuration).editInventoryItem(itemID, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This API allows the users to get all Deactivated Inventories
         * @summary Gets all Deactivated Inventories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDeactivatedInventories(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<GetAllInventoriesResponse>>> {
            const localVarAxiosArgs = await InventoryApiAxiosParamCreator(configuration).getAllDeactivatedInventories(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This API allows the users to get all Inventories
         * @summary Gets all Inventories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllInventories(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<GetAllInventoriesResponse>>> {
            const localVarAxiosArgs = await InventoryApiAxiosParamCreator(configuration).getAllInventories(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This API allows the users to retrieve a specific Collection items
         * @summary Gets All Items in a specific Collection
         * @param {string} collectionID ID of the collection to be used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionItems(collectionID: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<GetCollectionItemsResponse>>> {
            const localVarAxiosArgs = await InventoryApiAxiosParamCreator(configuration).getCollectionItems(collectionID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This API allows the users to retrieve a specific Inventory
         * @summary Gets Inventory by ID
         * @param {string} inventoryID ID of the Inventory to be used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventory(inventoryID: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<GetInventoryResponse>>> {
            const localVarAxiosArgs = await InventoryApiAxiosParamCreator(configuration).getInventory(inventoryID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This API allows the users to retrieve a specific Inventory Collection Fields
         * @summary Gets All Fields in a specific Inventory Collection
         * @param {string} collectionID ID of the Collection to be used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryCollectionFields(collectionID: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<GetInventoryCollectionFieldsResponse>>> {
            const localVarAxiosArgs = await InventoryApiAxiosParamCreator(configuration).getInventoryCollectionFields(collectionID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This API allows the users to retrieve a specific inventory item
         * @summary Gets an inventory Item by id
         * @param {string} itemID ID of the item to be modified
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryItem(itemID: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<GetInventoryItemResponse>>> {
            const localVarAxiosArgs = await InventoryApiAxiosParamCreator(configuration).getInventoryItem(itemID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * This API allows the users to retrieve inventory items by Name
         * @summary Gets inventory Items by Name
         * @param {string} Name Name of the item(s)
         * @param {number} [offset] Offset number for pagination
         * @param {number} [limit] Number of items per page for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryItemsByName(Name: string, offset?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<GetInventoryItemsByNameResponse>>> {
            const localVarAxiosArgs = await InventoryApiAxiosParamCreator(configuration).getInventoryItemsByName(Name, offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * API allows the users to change the status of inventory to active/inactive
         * @summary Toggle Inventory Status
         * @param {string} inventoryID ID of the Inventory to be used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleInventoryStatus(inventoryID: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<ToggleInventoryStatusResponse>>> {
            const localVarAxiosArgs = await InventoryApiAxiosParamCreator(configuration).toggleInventoryStatus(inventoryID, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * InventoryApi - factory interface
 * @export
 */
export const InventoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * This Api allows users to Add a new Item to a specific Collection in the inventory
         * @summary Add New Item to the Inventory Collection
         * @param {string} collectionID ID of the collection to be used
         * @param {Array<AddNewItemRequestInner>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNewItem(collectionID: string, body?: Array<AddNewItemRequestInner>, options?: AxiosRequestConfig): Promise<AxiosResponse<AddNewItemResponse>> {
            return InventoryApiFp(configuration).addNewItem(collectionID, body, options).then((request) => request(axios, basePath));
        },
        /**
         * This Api allows users to create a new Inventory
         * @summary Create new Inventory
         * @param {string} templateID ID of the template to be used
         * @param {CreateNewInventoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNewInventory(templateID: string, body?: CreateNewInventoryRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<CreateNewInventoryResponse>> {
            return InventoryApiFp(configuration).createNewInventory(templateID, body, options).then((request) => request(axios, basePath));
        },
        /**
         * This Api allows users to Delete an Item from a specific Collection
         * @summary Delete a specific Item
         * @param {string} collectionID ID of the collection to be modified
         * @param {string} itemID ID of the item to be used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInventoryItem(collectionID: string, itemID: string, options?: AxiosRequestConfig): Promise<AxiosResponse<DeleteInventoryItemResponse>> {
            return InventoryApiFp(configuration).deleteInventoryItem(collectionID, itemID, options).then((request) => request(axios, basePath));
        },
        /**
         * This API allows the users to edit the name of specific Inventory
         * @summary Edit Inventory Name
         * @param {string} inventoryID ID of the Inventory to be used
         * @param {EditInventoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editInventory(inventoryID: string, body?: EditInventoryRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<EditInventoryResponse>> {
            return InventoryApiFp(configuration).editInventory(inventoryID, body, options).then((request) => request(axios, basePath));
        },
        /**
         * This API allows the users to edit an item in a specific Inventory
         * @summary Edit Inventory Item
         * @param {string} itemID ID of the item to be modified
         * @param {Array<AddNewItemRequestInner>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editInventoryItem(itemID: string, body?: Array<AddNewItemRequestInner>, options?: AxiosRequestConfig): Promise<AxiosResponse<EditInventoryItemResponse>> {
            return InventoryApiFp(configuration).editInventoryItem(itemID, body, options).then((request) => request(axios, basePath));
        },
        /**
         * This API allows the users to get all Deactivated Inventories
         * @summary Gets all Deactivated Inventories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDeactivatedInventories(options?: AxiosRequestConfig): Promise<AxiosResponse<GetAllInventoriesResponse>> {
            return InventoryApiFp(configuration).getAllDeactivatedInventories(options).then((request) => request(axios, basePath));
        },
        /**
         * This API allows the users to get all Inventories
         * @summary Gets all Inventories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllInventories(options?: AxiosRequestConfig): Promise<AxiosResponse<GetAllInventoriesResponse>> {
            return InventoryApiFp(configuration).getAllInventories(options).then((request) => request(axios, basePath));
        },
        /**
         * This API allows the users to retrieve a specific Collection items
         * @summary Gets All Items in a specific Collection
         * @param {string} collectionID ID of the collection to be used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionItems(collectionID: string, options?: AxiosRequestConfig): Promise<AxiosResponse<GetCollectionItemsResponse>> {
            return InventoryApiFp(configuration).getCollectionItems(collectionID, options).then((request) => request(axios, basePath));
        },
        /**
         * This API allows the users to retrieve a specific Inventory
         * @summary Gets Inventory by ID
         * @param {string} inventoryID ID of the Inventory to be used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventory(inventoryID: string, options?: AxiosRequestConfig): Promise<AxiosResponse<GetInventoryResponse>> {
            return InventoryApiFp(configuration).getInventory(inventoryID, options).then((request) => request(axios, basePath));
        },
        /**
         * This API allows the users to retrieve a specific Inventory Collection Fields
         * @summary Gets All Fields in a specific Inventory Collection
         * @param {string} collectionID ID of the Collection to be used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryCollectionFields(collectionID: string, options?: AxiosRequestConfig): Promise<AxiosResponse<GetInventoryCollectionFieldsResponse>> {
            return InventoryApiFp(configuration).getInventoryCollectionFields(collectionID, options).then((request) => request(axios, basePath));
        },
        /**
         * This API allows the users to retrieve a specific inventory item
         * @summary Gets an inventory Item by id
         * @param {string} itemID ID of the item to be modified
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryItem(itemID: string, options?: AxiosRequestConfig): Promise<AxiosResponse<GetInventoryItemResponse>> {
            return InventoryApiFp(configuration).getInventoryItem(itemID, options).then((request) => request(axios, basePath));
        },
        /**
         * This API allows the users to retrieve inventory items by Name
         * @summary Gets inventory Items by Name
         * @param {string} Name Name of the item(s)
         * @param {number} [offset] Offset number for pagination
         * @param {number} [limit] Number of items per page for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryItemsByName(Name: string, offset?: number, limit?: number, options?: AxiosRequestConfig): Promise<AxiosResponse<GetInventoryItemsByNameResponse>> {
            return InventoryApiFp(configuration).getInventoryItemsByName(Name, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * API allows the users to change the status of inventory to active/inactive
         * @summary Toggle Inventory Status
         * @param {string} inventoryID ID of the Inventory to be used
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleInventoryStatus(inventoryID: string, options?: AxiosRequestConfig): Promise<AxiosResponse<ToggleInventoryStatusResponse>> {
            return InventoryApiFp(configuration).toggleInventoryStatus(inventoryID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InventoryApi - object-oriented interface
 * @export
 * @class InventoryApi
 * @extends {BaseAPI}
 */
export class InventoryApi extends BaseAPI {
    /**
     * This Api allows users to Add a new Item to a specific Collection in the inventory
     * @summary Add New Item to the Inventory Collection
     * @param {string} collectionID ID of the collection to be used
     * @param {Array<AddNewItemRequestInner>} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public async addNewItem(collectionID: string, body?: Array<AddNewItemRequestInner>, options?: AxiosRequestConfig) : Promise<AxiosResponse<AddNewItemResponse>> {
        return InventoryApiFp(this.configuration).addNewItem(collectionID, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This Api allows users to create a new Inventory
     * @summary Create new Inventory
     * @param {string} templateID ID of the template to be used
     * @param {CreateNewInventoryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public async createNewInventory(templateID: string, body?: CreateNewInventoryRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<CreateNewInventoryResponse>> {
        return InventoryApiFp(this.configuration).createNewInventory(templateID, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This Api allows users to Delete an Item from a specific Collection
     * @summary Delete a specific Item
     * @param {string} collectionID ID of the collection to be modified
     * @param {string} itemID ID of the item to be used
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public async deleteInventoryItem(collectionID: string, itemID: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<DeleteInventoryItemResponse>> {
        return InventoryApiFp(this.configuration).deleteInventoryItem(collectionID, itemID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This API allows the users to edit the name of specific Inventory
     * @summary Edit Inventory Name
     * @param {string} inventoryID ID of the Inventory to be used
     * @param {EditInventoryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public async editInventory(inventoryID: string, body?: EditInventoryRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<EditInventoryResponse>> {
        return InventoryApiFp(this.configuration).editInventory(inventoryID, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This API allows the users to edit an item in a specific Inventory
     * @summary Edit Inventory Item
     * @param {string} itemID ID of the item to be modified
     * @param {Array<AddNewItemRequestInner>} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public async editInventoryItem(itemID: string, body?: Array<AddNewItemRequestInner>, options?: AxiosRequestConfig) : Promise<AxiosResponse<EditInventoryItemResponse>> {
        return InventoryApiFp(this.configuration).editInventoryItem(itemID, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This API allows the users to get all Deactivated Inventories
     * @summary Gets all Deactivated Inventories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public async getAllDeactivatedInventories(options?: AxiosRequestConfig) : Promise<AxiosResponse<GetAllInventoriesResponse>> {
        return InventoryApiFp(this.configuration).getAllDeactivatedInventories(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This API allows the users to get all Inventories
     * @summary Gets all Inventories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public async getAllInventories(options?: AxiosRequestConfig) : Promise<AxiosResponse<GetAllInventoriesResponse>> {
        return InventoryApiFp(this.configuration).getAllInventories(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This API allows the users to retrieve a specific Collection items
     * @summary Gets All Items in a specific Collection
     * @param {string} collectionID ID of the collection to be used
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public async getCollectionItems(collectionID: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<GetCollectionItemsResponse>> {
        return InventoryApiFp(this.configuration).getCollectionItems(collectionID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This API allows the users to retrieve a specific Inventory
     * @summary Gets Inventory by ID
     * @param {string} inventoryID ID of the Inventory to be used
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public async getInventory(inventoryID: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<GetInventoryResponse>> {
        return InventoryApiFp(this.configuration).getInventory(inventoryID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This API allows the users to retrieve a specific Inventory Collection Fields
     * @summary Gets All Fields in a specific Inventory Collection
     * @param {string} collectionID ID of the Collection to be used
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public async getInventoryCollectionFields(collectionID: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<GetInventoryCollectionFieldsResponse>> {
        return InventoryApiFp(this.configuration).getInventoryCollectionFields(collectionID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This API allows the users to retrieve a specific inventory item
     * @summary Gets an inventory Item by id
     * @param {string} itemID ID of the item to be modified
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public async getInventoryItem(itemID: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<GetInventoryItemResponse>> {
        return InventoryApiFp(this.configuration).getInventoryItem(itemID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This API allows the users to retrieve inventory items by Name
     * @summary Gets inventory Items by Name
     * @param {string} Name Name of the item(s)
     * @param {number} [offset] Offset number for pagination
     * @param {number} [limit] Number of items per page for pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public async getInventoryItemsByName(Name: string, offset?: number, limit?: number, options?: AxiosRequestConfig) : Promise<AxiosResponse<GetInventoryItemsByNameResponse>> {
        return InventoryApiFp(this.configuration).getInventoryItemsByName(Name, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * API allows the users to change the status of inventory to active/inactive
     * @summary Toggle Inventory Status
     * @param {string} inventoryID ID of the Inventory to be used
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public async toggleInventoryStatus(inventoryID: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<ToggleInventoryStatusResponse>> {
        return InventoryApiFp(this.configuration).toggleInventoryStatus(inventoryID, options).then((request) => request(this.axios, this.basePath));
    }
}
